<template>
   <Modal
    v-model="isShow"
    :width="500"
    :loading="loading"
    :mask-closable="false"
  >
    <h3 slot="header" class="modal-header">修改商户</h3>
    <Form
			ref="addData"
			:model="addData"
			:rules="ruleValidate"
			:label-width="140"
			>
      <Row >
				<Col span="20">
					<FormItem prop="acMerchantName" label="商户名">
						<Input v-model="addData.acMerchantName" placeholder="请输入商户名"></Input>
					</FormItem>
				</Col>
      </Row>
      <Row>
        <Col span="20">
					<FormItem prop="acMerchantNo" label="商户号">
						<Input v-model="addData.acMerchantNo" placeholder="请输入商户号"></Input>
					</FormItem>
				</Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="ok">
        <span>保存</span>
      </Button>
    </div>
   </Modal>
</template>

<script>
import { update, getMerchantInfoByFid } from '@/api/MerchantMng'
export default {
  name:'Add',
  props:{
    n:{
      type:Number,
			default:0
    },
    fid:{
      type:String,
			default: ''
    }
  },
  data(){
    return {
      isShow:false,
      addData:{},
      loading:true,
      ruleValidate:{
        acMerchantName:[
          { required: true, message: '请输入商户名', trigger: 'blur',type:'string'}
        ],
        acMerchantNo:[
          { required: true, message: '商户号不能为空且只可填写数字', trigger: 'blur',validator: this.validateNumber}
        ]
      }
    }
  },
  watch:{
    n(){
      this.isShow = true;
      this.$refs['addData'].resetFields()
      this.getData();
    }
  },
  methods:{
    validateNumber(rule, value, callback) {
      let pattern = /^\d+$/
      if (!pattern.test(value)) {
        callback(new Error('请输入正确数字'));
      }
      callback();
    },
    getData(){
      getMerchantInfoByFid({'merchantFid':this.fid})
      .then(res=>{
        this.addData = res.data;
        console.log(res,'xxx')
      })
    },
    ok(){
      let validate = true
      this.$refs['addData'].validate( bool => {
        if(bool){
					console.log()
        } else{
          validate = false
          this.changeLoading();
        }
      })
      if (!validate) {
        this.changeLoading()
        return
      }
      update({
        acMerchantName:this.addData.acMerchantName,
        acMerchantNo:this.addData.acMerchantNo,
        fid:this.addData.fid
      })
      .then(res=>{
        this.$Message.success('修改成功')
        this.$emit('findData')
        this.isShow = false
      })
    },
    changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
    handleCancel(){
      this.isShow = false
    }
  }
}
</script>

<style>

</style>